export default __webpack_public_path__ + "static/media/lojaderoupas-970x1333.67f24c89.jpg";